import firebase from "firebase/app";
import "firebase/firestore";

firebase.initializeApp({
  apiKey: "AIzaSyBIJhLMNJ6VTr1VsapxBIvTJWds7pCKNuk",
  authDomain: "tramvene-49a07.firebaseapp.com",
  projectId: "tramvene-49a07",
  storageBucket: "tramvene-49a07.appspot.com",
  messagingSenderId: "136439150384",
  appId: "1:136439150384:web:437ca3d75fdb64a6e17af5",
});

let db = firebase.firestore();

export { firebase, db };
